import { z } from "zod";

// @TODO(todd): Better schema here.
export const employeeTaxParameterSchema = z.any();
